import React from 'react';
import { Modal } from 'fpay-ui';

import { useTransaction } from 'hooks';
import HeaderTransactionsDetailModal from './HeaderTransactionsDetailModal';
import TableTransactionsModal from './TableTransactionsModal';

const TransactionsDetailModal = ({ fClose, headerData }) => {
  const { currentTransaction } = useTransaction();

  return (
    <Modal fClose={fClose} width="960px" borderRadius="16px" htmlIdClose="transactions-see-detail-close" htmlIdBackground="transactions-see-detail-close-bkgd">
      <HeaderTransactionsDetailModal data={headerData} />
      <TableTransactionsModal
        handleCloseError={fClose}
        data={headerData}
        currentTransaction={currentTransaction}
      />
    </Modal>
  );
};

export default TransactionsDetailModal;
